//
//	The main user container element
//
import React, { Component } from 'react';
import User from 'src/components/parts/User';
import UserSort from 'src/components/parts/UserSort';
import { connect } from "react-redux";
//import { sessionService } from 'redux-react-session';
//import { sessionReducer } from 'redux-react-session';
import { setUsers } from "src/cms.js";

const mapStateToProps = state  => {
	return {
		users: state.users,
		usersVisible: state.usersVisible,
		usersTotal: state.usersTotal,
		showItems: state.showItems,
		userOrder: state.userOrder,
		usersCompleteLoad: state.usersCompleteLoad,
		showMoreDelay: state.showMoreDelay,
	};
};

class UserContainer extends Component {

	constructor(props) {

		super(props);

	}

	//	On Load
	componentDidMount() {

		// temp commented to work with only getting current user..
		//setUsers( this.props );
		
		// Call back to start track scrolling
		document.addEventListener('scroll', this.trackScrolling);

	}

	//	On Remove
	componentWillUnmount() {

		//	stop tracking scolling
		document.removeEventListener('scroll', this.trackScrolling);

	}
	
	// Function to track when user start scrolling.
	trackScrolling = () => {
		console.log( 'scrolling' )
		// This is where we will trigger a complete load of users. 
		if( !this.props.usersCompleteLoad ){
			
			this.props.dispatch({type: 'GET_ALL_USERS_STARTED'});
			
			setUsers( this.props )
			
		}

		const userBlockBottom = document.getElementsByClassName('users')[0].getBoundingClientRect().bottom;
		

		// 1. When user is 1x height of device away from bottom.
		// 2. Make sure more loading only happens once every second.
		// 3. do not show if max users already loaded.
		if( userBlockBottom <= (window.innerHeight * 2) && !this.props.showMoreDelay && this.props.usersVisible.length !== this.props.users.length ) {
			console.log( 'More users called through scrolling.' );
			//	After we set users from the complete load we will want to show additional users to fix the scrolling issue and also make it look like more users have loaded.
			this.props.dispatch({type: 'MORE_USERS'});

			// 	Issue was fixed but as a note -> Issue still is if we scroll very fast and hit bottom of page before 1 second it won't load more. ( this is only on desk top though since scroll will still trigger even more on mobile.)
			//	Delay loading additional users for 2 seconds
			setTimeout(() => { this.props.dispatch({type: 'MORE_USERS_DONE'}); }, 1000 );
			
		}
	};


	//	Display User box section
	render() {
	  return (
		<div>
		  {this.props.showOrderBox ? <UserSort /> : null}
          <div className="users">
		  {this.props.usersVisible.map( (user) => 
				<User key={user.id} info={user} />
            )}
          </div>
		  {this.props.showMoreDelay ? <div className="more-users-loading">Loading More Girls ❤❤❤</div> : null}
        </div>
	  );
	}
}


export default connect(mapStateToProps)(UserContainer);


// WEBPACK FOOTER //
// ./src/components/parts/UserContainer.js